import React from 'react'
import Select from './fields/Select'
import Range from './fields/Range'
import Input from './fields/Input'
import Checkbox from './fields/Checkbox'

class SearchForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // displayExtra: (window.innerWidth > 1024)
      displayExtra: true
    }
  }

  handleChange = field => val => {
    // Input fields give an event, the others just give the value
    const fieldVal = typeof val === 'object' && 'nativeEvent' in val ? val.target.value : val
    const form = {
      ...this.props.searchState,
      [field]: fieldVal,
    }
    this.props.setSearchState(form)
  }

  renderField = fieldKey => {
    const fieldTypes = {
      select: Select,
      range: Range,
      input: Input,
      checkbox: Checkbox,
    }
    const field = this.props.fields[fieldKey]
    if (!(field.type in fieldTypes) || !(fieldKey in this.props.searchState)) return
    const TagName = fieldTypes[field.type]
    const width = field.width || '24'
    const isExtraClass = field.extra ? 'field--extra' : ''
    const elementProps = {}
    if (field.type === 'input') elementProps.onPressEnter = this.handleSubmit
    return <div key={fieldKey} className={`ant-col-md-${width} ${isExtraClass} gw-search__key-${fieldKey}`}><TagName field={field} onChange={this.handleChange(fieldKey)} value={this.props.searchState[fieldKey]} elementProps={elementProps} /></div>
  }

  renderFields = () => {
    return (
      <div className="gw-search-form__fields ant-row">
        {Object.keys(this.props.fields).map(this.renderField)}
      </div>
    )
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.setSearchState({
      ...this.props.searchState,
      searchIsDirty: true,
    })
    this.props.onSubmit()
  }

  displayExtraFields = (e) => {
    e.preventDefault()
    this.setState({
      ...this.state,
      displayExtra: true,
    })
  }

  clearSearch = (e) => {
    e.preventDefault()
    const search = {
      ...this.props.searchState,
      searchIsDirty: false,
    }
    Object.keys(this.props.fields).forEach(fieldKey => {
      search[fieldKey] = this.props.fields[fieldKey].default || ''
    })
    this.props.setSearchState(search, this.props.onSubmit)
  }

  renderClearSearch = () => {
    if (!this.props.searchState.searchIsDirty) return
    return (
      <div className="search__clear-row">
        <button type="button" onClick={this.clearSearch}><span className="icon-plus"></span>{this.props.strings.clear_search}</button>
      </div>
    )
  }

  render() {
    const displayExtraClass = this.state.displayExtra ? 'search--extra' : ''
    return (
      <div className={`gw-search-form ${displayExtraClass}`}>
        <form onSubmit={this.handleSubmit}>
          {this.renderFields()}
          <div className="search__button-row">
            <div className="expand-input-wrap">
              <button className="avia-button avia-color-theme-color" onClick={this.displayExtraFields}>
                <span className="icon-plus"></span>
                {this.props.strings.more_detail}
              </button>
            </div>
            {this.renderClearSearch()}
            <div className="search-input-wrap">
              <button type="submit" className="avia-button avia-color-theme-color-subtle button--icon-right">
                {this.props.strings.search}
                <span className="icon-search" />
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default SearchForm



// WEBPACK FOOTER //
// ./src/components/search/SearchForm.js